import React, { Component } from "react";
import { Link } from "react-router-dom";
export default class TermsandConditions extends Component {
  render() {
    return (
      <div className="container p-4">
        <div className="text-center">
          <img src="/images/logo.jpg" width="201" height="40" alt="logo" />
        </div>
        <div style={{ textAlign: "left" }}>
          <h5>
            <u>
              <b>
                <span style={{ color: "darkred" }}>Terms &</span> 
                <span style={{ color: "darkslateblue" }}>Conditions /</span>{" "}
                <span style={{ color: "darkred" }}>Privacy</span>{" "}
                <span style={{ color: "darkslateblue" }}>Policy</span>
              </b>
            </u>
          </h5>
        </div>
        <p className="p-2">
          Welcome to ekyc.ameyalogistics.com (this "Site"), the website
          maintained by Ameya Logistics and its business units are collectively
          referred to as "us", "our" or the "Company" in these Terms &
          Conditions/ Privacy Policy. Terms & Conditions/ Privacy Policy set
          forth the terms and conditions under which users are authorized to
          have access to and use this Site.
        </p>
        <div>
          <h5>
            <b>Acceptance</b>
          </h5>
        </div>
        <p>
          Any use of this Site by you conclusively indicates that this Privacy
          Policy has been reviewed and accepted by you. If you do not agree with
          any of the provisions of this Terms & Conditions/ Privacy Policy, you
          should not use this Site.
        </p>
        <div>
          <h5>
            <b>Content</b>
          </h5>
        </div>
        <p>
          The content of this Site ("Content") is the property of the Company,
          and all right, title and interest in all Content belongs solely to the
          Company. You may access and use Content for any legitimate business
          purpose; provided, however, that you may not use this Site or any
          Content for any purpose prohibited by the Company, in its sole
          discretion, upon notice of such prohibited purpose from the Company.
          Any access or attempt to access other areas of any computer equipment
          on which this Site is located, or other information contained on such
          computer equipment for any purpose, is prohibited.{" "}
        </p>
        <div>
          <h5>
            <b>Intellectual Property Rights</b>
          </h5>
        </div>
        <p>
          The Company owns and operates this Site. Unless identified with the
          designation "Copy Free", all names, titles, logos, and designs
          identifying the products and brands of the Company -- including any
          derivative and related names, titles, logos and designs, appearing in
          this Site -- are trademarks of the Company and its sole property. Any
          other names, titles, logos and designs appearing on this Site are the
          property of their respective owners.
        </p>
        <p>
          This Site contains copyrighted material, trademarks and other
          proprietary information, including, but not limited to, text,
          photographs, graphics, images, illustrations and software, and the
          entire Content is protected by copyright as a collective work and/or
          compilation under the United States copyright laws, international
          conventions and other copyright laws. The Company owns a copyright in
          the Content original and in the selection, coordination, arrangement
          and enhancement of all content.
        </p>
        <p>
          Any reproduction, modification, publication, transmission,
          retransmission, framing, misuse, misappropriation, unauthorized use,
          transfer, sale, distribution, performance, display, creation of a
          derivative work or any other exploitation of any Content, in whole or
          in part, without the express written consent of the Company is
          strictly prohibited. Notwithstanding the foregoing, any user of this
          Site is granted a limited license to download Content for personal use
          only provided that all copyright and other notices in any downloaded
          Content are maintained. By downloading Content, the user agrees and
          acknowledges that the user does not acquire any ownership or other use
          rights to any Content or this Site by downloading such Content. Except
          as expressly authorized above, nothing contained in this Site or these
          Terms & Conditions/ Privacy Policy shall be construed as conferring,
          by implication, estoppels or otherwise, any license or right under any
          patent, trademark, copyright or other property right of the Company or
          any third party.
        </p>
        <p>
          Individual documents published by the Company on this Site may contain
          other proprietary notices and copyright information specific to such
          individual document. Any product, process, or technology in such
          individual documents may be the subject of other intellectual property
          rights reserved by the Company or a third party and are not to be
          licensed under these Terms & Conditions/ Privacy Policy. If you are
          interested in using any Content in any manner except as expressly
          authorized above, you should contact the Company for information on
          licensing.
        </p>
        <div>
          <h5>
            <b>Disclaimer of Warranty and Limitation of Liability</b>
          </h5>
        </div>
        <p>
          Neither the Company nor any of its affiliates, officers, directors,
          employees, third party content providers, licensors, agents or
          representatives makes any warranty or representation of any kind,
          either express or implied, with respect to this Site, any Content or
          any products or services offered through this Site, including, but not
          limited to, any warranty that this Site will be operable,
          uninterrupted, virus free or error free, any warranty of title, any
          warranty of privacy, any warranty of dependability, accuracy,
          timeliness, authenticity, completeness or reliability, or any warranty
          of merchantability or fitness for a particular purpose.
        </p>
        <p>
          By using this Site, you acknowledge and agree that this Site and all
          Content are provided on an "as is, where at" basis without any
          warranty or representation of any kind, either express or implied,
          with respect to this Site, any Content or any products or services
          offered through this Site, including, but not limited to, any warranty
          that this Site will be operable, uninterrupted, virus free or error
          free, any warranty of title, any warranty of privacy, any warranty of
          dependability, accuracy, timeliness, authenticity, completeness or
          reliability, or any warranty of merchantability or fitness for a
          particular purpose.{" "}
        </p>
        <p>
          Any reproduction, modification, publication, transmission,
          retransmission, framing, misuse, misappropriation, unauthorized use,
          transfer, sale, distribution, performance, display, creation of a
          derivative work or any other exploitation of any Content, in whole or
          in part, without the express written consent of the Company is
          strictly prohibited. Notwithstanding the foregoing, any user of this
          Site is granted a limited license to download Content for personal use
          only provided that all copyright and other notices in any downloaded
          Content are maintained. By downloading Content, the user agrees and
          acknowledges that the user does not acquire any ownership or other use
          rights to any Content or this Site by downloading such Content. Except
          as expressly authorized above, nothing contained in this Site or these
          Terms & Conditions/ Privacy Policy shall be construed as conferring,
          by implication, estoppels or otherwise, any license or right under any
          patent, trademark, copyright or other property right of the Company or
          any third party.
        </p>
        <p>
          In no event will the Company or any of its affiliates, officers,
          directors, employees, third party content providers, licensors,
          agents, or representatives be liable to any person or entity for
          damages of any nature whatsoever arising out of or in connection with
          the use of this Site or any linked web site. This is a comprehensive
          limitation of liability that you agree is fair and reasonable
          concerning your use of this Site and applies to all harm, liabilities,
          injuries, losses, damages, costs and expenses of any kind whatsoever,
          including, but not limited to, direct, indirect, incidental, special,
          compensatory, or consequential damages, regardless of how same arise,
          whether in tort, negligence, statute, contract, common law, equity or
          otherwise, and whether for or in connection with loss of programs or
          data, loss of income, revenues or profits, loss of anticipated sales,
          loss of opportunity, business interruption, failure to realize
          expected savings, damage to person or property, claims of third
          parties or otherwise.
        </p>
        <div>
          <h5>
            <b>Links</b>
          </h5>
        </div>
        <p>
          This Site may from time to time be linked to other web sites. The
          Company is not responsible for any content contained on any web site
          that is not maintained by the Company. No link from this Site to a
          third party web site, or from a third party web site to this Site, is
          an endorsement, sponsorship or recommendation by the Company of such
          third party web site. The Company will have no liability to users
          arising from any link from a third party web site to this Site or from
          this Site to a third party web site.
        </p>
        <div>
          <h5>
            <b>Information Provided</b>
          </h5>
        </div>
        <p>
          All comments, graphics, ideas and other information you provide to the
          Company through this Site will become the property of the Company
          without any compensation to the user. To the extent you are requested
          to provide any information to the Company while using this Site, you
          represent and warrant that such information will be accurate and
          complete in all respects.
        </p>
        <div>
          <h5>
            <b>Information Collected</b>
          </h5>
        </div>
        <p>
          Company may collect information about you and your use of this Site
          (including, but not limited to, your name, email address, street
          address and telephone number, credit card information, and length of
          time spent by you on this Site) for many purposes. You consent to the
          Company's use of such information for any lawful purpose. Any
          personally identifiable information you provide through this Site
          (e.g., information that can identify the user, including, but not
          limited to, your name, email address, street address, telephone
          number, employer and occupational title) will be subject to this
          Privacy Policy.
        </p>
        <p>
          This Site contains copyrighted material, trademarks and other
          proprietary information, including, but not limited to, text,
          photographs, graphics, images, illustrations and software, and the
          entire Content is protected by copyright as a collective work and/or
          compilation under the United States copyright laws, international
          conventions and other copyright laws. The Company owns a copyright in
          the Content original and in the selection, coordination, arrangement
          and enhancement of all content.
        </p>
        <p>
          The Personal Data provided by Customers will be used by KYC for the
          purposes of processing for any one or more of the following Prevention
          of Money Laundering Act, 2002;
        </p>
        <p>
          The Company collects and uses the financial information and other
          personal information from its customers. This information is collected
          and used for specific business purposes or for other related purposes
          designated by the Company or for a lawful purpose to comply with the
          applicable laws and regulations. The Company shall not divulge any
          personal information collected from the customer, for cross selling or
          any other purposes.
          <p>
            The authenticity of the personal information provided by the
            customer shall not be the responsibility of the Company. Any
            information that is freely available or accessible in public domain
            or furnished under the Right to Information Act, 2005 or any other
            law for the time being in force shall not be regarded as personal
            information for the purposes of this Policy and the Company shall
            not be responsible for the same.
          </p>
        </p>
        <div>
          <h5>
            <b>Misuse of Information</b>
          </h5>
        </div>
        <p>
          The Company uses precautions to protect information provided by you to
          the Company through this Site from misuse or unauthorized disclosure
          in accordance with this Privacy Policy. However, the Company does not
          guarantee that any such information is secure from misuse or
          unauthorized disclosure, and the Company will not have any liability
          to you for any misuse or unauthorized disclosure of such information.
        </p>
        <div>
          <h5>
            <b>Indemnification and Hold Harmless</b>
          </h5>
        </div>
        <p>
          You understand and expressly agree that all access to and use of this
          Site is at your sole risk. You will indemnify and hold harmless the
          Company from and against all harm, liabilities, injuries, losses,
          damages, costs and expenses incurred by the Company (including, but
          not limited to, fees and disbursements of counsel to the Company) in
          connection with your access to or use of this Site or any Content,
          except to the extent such harm, liabilities, injuries, losses,
          damages, costs or expenses are due solely to the negligence of the
          Company.
        </p>
        <p>
          You agree that you shall not take any action against the Company or
          any of its affiliates, officers, directors, employees, third party
          content providers, licensors, agents, or representatives in any
          connection with any matter relating to or arising out of your access
          to or use of this Site.
        </p>
        <div>
          <h5>
            <b>Termination and Modification</b>
          </h5>
          <p>
            Ameya Logistics may terminate this Site and modify any Content at
            any time, in each case, without notice to you and without liability
            to you for such termination or modification.
          </p>
        </div>
        <div>
          <h5>
            <b>Notices</b>
          </h5>
        </div>
        <p>
          You may send notices. Any such notice will be effective upon actual
          receipt by the Company. The Company may send notices to you through
          email, regular mail or a posting on this Site. Any such notice will be
          effective upon actual receipt by you in the case of email or regular
          mail or upon posting in the case of posting on this Site.
        </p>
        <div>
          <h5>
            <b>Disclosure of Personal Information</b>
          </h5>
        </div>
        <p>
          The personal information collected by the Company shall not be
          disclosed to any other organization except:
          <ul style={{ margin: "0px 0px 0px -30px" }}>
            <li>
              where the disclosure has been agreed in a written contract or
              otherwise between the Company and the customer.
            </li>
            <li>
              where the Company is required to disclose the personal information
              to a third party on a need-to-know basis, provided that in such
              case the Company shall inform such third party of the confidential
              nature of the personal information and shall keep the same
              standards of information/ data security as that of the Company.{" "}
            </li>
          </ul>
        </p>
        <div>
          <h5>
            <b>Reasonable Security Practices and Procedures</b>
          </h5>
        </div>
        <p>
          The security of personal information is a priority and is protected by
          maintaining physical, electronic, and procedural safeguards that meet
          applicable laws. The Company shall take reasonable steps and measures
          to protect the security of the customer’s personal information from
          misuse and loss, un-authorized access, modification or disclosure. The
          Company maintains its security systems to ensure that the personal
          information of the customer is appropriately protected and follows the
          extant standard encryption norms followed for the transmission of
          information. The Company ensures that its employees and affiliates
          respect the confidentiality of any personal information held by the
          Company.
        </p>
        <div>
          <h5>
            <b>Miscellaneous</b>
          </h5>
        </div>
        <p>
          These Terms & Conditions / Privacy Policy:
          <ol type="a" style={{ margin: "0px 0px 0px -30px" }}>
            <li>
              May be amended by Ameya Logistics at any time without notice to
              you;
            </li>
            <li>
              Ameya Logistics inure to the benefit of and are binding upon you
              and the Company and each of your and the Company's successors and
              assigns, except that you may not assign any of your obligations
              under these Terms & Conditions / Privacy Policy without the
              written consent of Ameya Logistics;
            </li>
            <li>
              shall be governed by, and interpreted and enforced in accordance
              with, the internal law of the State of India without regard to
              principles of conflict of laws, and
            </li>
            <li>
              Constitute the entire agreement and understanding between you and
              the Company with respect to your access to and use of this Site
              and supersede all prior oral and written proposals,
              representations, understandings and agreements.
            </li>
          </ol>
        </p>
        <div className="col-6">
          <Link to="/Login">
            <button className="btn btn-primary px-2" type="button">
              Back
            </button>
          </Link>
        </div>
      </div>
    );
  }
}
